module.exports = __webpack_public_path__ + "static/media/iFlythere_video.7feae467.png";